import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=b7b95890&scoped=true"
import script from "./LogoutButton.vue?vue&type=script&lang=ts"
export * from "./LogoutButton.vue?vue&type=script&lang=ts"
import style0 from "./LogoutButton.vue?vue&type=style&index=0&id=b7b95890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b95890",
  null
  
)

export default component.exports